var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteOutlinedSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3346 3.33333H13.168V1.66667C13.168 1.22464 12.9924 0.800716 12.6798 0.488155C12.3673 0.175595 11.9433 0 11.5013 0L6.5013 0C6.05927 0 5.63535 0.175595 5.32279 0.488155C5.01023 0.800716 4.83464 1.22464 4.83464 1.66667V3.33333H0.667969V5H2.33464V17.5C2.33464 18.163 2.59803 18.7989 3.06687 19.2678C3.53571 19.7366 4.17159 20 4.83464 20H13.168C13.831 20 14.4669 19.7366 14.9357 19.2678C15.4046 18.7989 15.668 18.163 15.668 17.5V5H17.3346V3.33333ZM6.5013 1.66667H11.5013V3.33333H6.5013V1.66667ZM14.0013 17.5C14.0013 17.721 13.9135 17.933 13.7572 18.0893C13.6009 18.2455 13.389 18.3333 13.168 18.3333H4.83464C4.61362 18.3333 4.40166 18.2455 4.24538 18.0893C4.0891 17.933 4.0013 17.721 4.0013 17.5V5H14.0013V17.5Z",
    fill: "#DA1E27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 8.33301H6.5V14.9997H8.16666V8.33301Z",
    fill: "#DA1E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5026 8.33301H9.83594V14.9997H11.5026V8.33301Z",
    fill: "#DA1E27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlinedSmall);
export default __webpack_public_path__ + "static/media/deleteOutlinedSmall.dd5a3d98198707f8a1d83a5125491eb2.svg";
export { ForwardRef as ReactComponent };